var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycAnalyzeFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 251,
    viewBox: "0 0 240 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7974 205.442C41.8694 214.17 55.7181 205.253 48.3982 192.941L32.7974 205.442Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83462 190.711C2.87934 187.521 4.85548 184.717 7.50833 182.661L24 169.553C26.8 169.553 43.1667 183.658 51 190.711L28.5087 208.875C26.7919 210.296 24.8094 211.362 22.6767 212.01C20.5445 212.658 18.3045 212.876 16.0875 212.649C13.8705 212.422 11.7208 211.757 9.7638 210.69C7.8065 209.624 6.08084 208.179 4.68731 206.44C3.29377 204.7 2.2602 202.701 1.64677 200.558C0.724467 197.331 0.789892 193.901 1.83462 190.711Z",
    fill: "#2F68E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3902 117.047C94.6479 127.078 101.984 135.873 110.909 142.845L104.5 148.053C98.8647 141.719 85.8348 128.353 78.7971 125.553L89.3902 117.047Z",
    fill: "#2F68E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83462 190.711C2.87934 187.521 4.85548 184.717 7.50833 182.661L24 169.553C26.8 169.553 43.1667 183.658 51 190.711L28.5087 208.875C26.7919 210.296 24.8094 211.362 22.6767 212.01C20.5445 212.658 18.3045 212.876 16.0875 212.649C13.8705 212.422 11.7208 211.757 9.7638 210.69C7.8065 209.624 6.08084 208.179 4.68731 206.44C3.29377 204.7 2.2602 202.701 1.64677 200.558C0.724467 197.331 0.789892 193.901 1.83462 190.711Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3902 117.047C94.6479 127.078 101.984 135.873 110.909 142.845L104.5 148.053C98.8647 141.719 85.8348 128.353 78.7971 125.553L89.3902 117.047Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.285 202.242L103.994 232.277C108.57 238.342 113.391 244.738 117.75 250.104L158.376 221.664C154.128 215.113 149.764 208.638 145.285 202.242Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.388 155.223C98.2557 138.986 81.7869 125.258 73.6019 123.547C65.417 121.837 58.2506 123.36 55.4696 130.844C52.8777 131.392 50.4498 132.538 48.3789 134.191C46.3081 135.843 44.6516 137.956 43.5413 140.362C35.8494 140.877 28.928 143.348 26.212 152.66C18.0329 153.809 11.6282 160.348 10.5137 165.994C9.57023 170.473 9.93977 175.13 11.578 179.404L24.3801 169.147C28.8084 172.394 41.6342 182.063 45.5931 185.871C56.2209 196.097 71.6476 215.771 86.9148 211.23C89.9777 213.666 96.6571 222.549 103.995 232.279L145.285 202.239C132.156 183.466 120.403 168.63 110.388 155.223Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.209 152.661C32.6359 151.608 40.068 152.823 51.8458 163.572",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4673 130.844C65.7999 128.749 73.328 135.567 79.3092 141.715",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3142 151.471C63.6673 147.95 60.2231 145.108 56.2643 143.177C52.3054 141.245 47.945 140.281 43.541 140.362",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.694 159.615C203.494 159.615 239.001 124.108 239.001 80.3076C239.001 36.5074 203.494 1 159.694 1C115.894 1 80.3862 36.5074 80.3862 80.3076C80.3862 124.108 115.894 159.615 159.694 159.615Z",
    fill: "#2948A7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.695 7.3623C140.35 7.36328 121.797 15.0492 108.118 28.7293C94.4394 42.4094 86.7554 60.963 86.7563 80.3086C86.7573 99.6542 94.4433 118.207 108.123 131.886C121.803 145.564 140.357 153.249 159.703 153.248C179.048 153.247 197.601 145.561 211.28 131.881C224.959 118.2 232.643 99.6468 232.642 80.3013C232.641 60.9557 224.955 42.4028 211.275 28.7241C197.595 15.0454 179.041 7.36133 159.695 7.3623Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.06 47.5527C149.293 47.5522 140.884 51.0346 134.684 57.2339C128.484 63.4332 125.001 71.8415 125 80.6091C124.999 89.3767 128.482 97.7854 134.681 103.985C140.88 110.185 149.289 113.669 158.056 113.669C166.824 113.67 175.233 110.187 181.433 103.988C187.633 97.7889 191.116 89.3806 191.117 80.613C191.117 71.8454 187.635 63.4366 181.435 57.2366C175.236 51.0367 166.828 47.5532 158.06 47.5527Z",
    fill: "#90B1FB",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.657 103.761C178.581 100.622 174.91 98.1278 170.858 96.4253C166.806 94.7227 162.455 93.8457 158.06 93.8457C153.665 93.8457 149.314 94.7227 145.263 96.4253C141.211 98.1278 137.539 100.622 134.464 103.761C137.541 106.897 141.213 109.389 145.265 111.089C149.316 112.79 153.666 113.666 158.06 113.666C162.454 113.666 166.804 112.79 170.856 111.089C174.907 109.389 178.579 106.897 181.657 103.761Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.718 86.9337C160.056 86.9337 163.257 85.6078 165.617 83.2478C167.977 80.8877 169.303 77.6868 169.303 74.3492C169.303 71.0115 167.977 67.8106 165.617 65.4506C163.257 63.0905 160.056 61.7646 156.718 61.7646C153.38 61.7646 150.18 63.0905 147.819 65.4506C145.459 67.8106 144.134 71.0115 144.134 74.3492C144.134 77.6868 145.459 80.8877 147.819 83.2478C150.18 85.6078 153.38 86.9337 156.718 86.9337Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208 64.1317V40.5527C208 36.1345 204.418 32.5527 200 32.5527H176.168M143.832 32.5527H120C115.582 32.5527 112 36.1345 112 40.5527V64.1317M112 96.7212V120.553C112 124.971 115.582 128.553 120 128.553H143.832M176.168 128.553H200C204.418 128.553 208 124.971 208 120.553V96.7212",
    stroke: "#2948A7",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 140.051,
    r: 29.75,
    fill: "#FF7373",
    stroke: "black",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190 127.551L215.5 153.051",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190 127.551L215.5 153.051",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 127.551L190 153.051",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 127.551L190 153.051",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycAnalyzeFailed);
export default __webpack_public_path__ + "static/media/kyc_analyze_failed.1cd6b171a030d479870244c68a1738bd.svg";
export { ForwardRef as ReactComponent };